import { generateUOMConversionURL } from "c8-platform";
import resolver from "csi/resolver";
import New from "csi/table/New";
import { C8Node } from "csi/typings";
import declare from "dojo/_base/declare";

const UOM_TYPE = "ConversionType";
const EXTERNAL_UOM = "ExternalUOM";
const INTERNAL_UOM = "InternalUOM";

const NewUOMConversion = declare(New, {

	/**
	 * @override
	 * Show newly created UOMConversion nodes
	 */
	getNewNodes(): C8Node[] {
		const formData = this.getFormData();
		const uomTypeName = this.m_cache.getNode(formData.getFieldValue(UOM_TYPE), true).$Name;
		const uomIntName = this.m_cache.getNode(formData.getFieldValue(INTERNAL_UOM), true).$Name;
		const uomExtName = this.m_cache.getNode(formData.getFieldValue(EXTERNAL_UOM), true).$Name;
		const newIntToExtUOMConversion = resolver.resolveNode(generateUOMConversionURL(uomTypeName, uomIntName, uomExtName), true, null);
		const newExtToIntUOMConversion = resolver.resolveNode(generateUOMConversionURL(uomTypeName, uomExtName, uomIntName), true, null);

		return [newIntToExtUOMConversion, newExtToIntUOMConversion];
	},

});

export = NewUOMConversion;